export default function Settings() {
  return (
    <div className="p-6 text-gray-500 italic">
      Settings page coming soon...
    </div>
  );
}
